import { Container, createStyles, Grid, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import MessageIcon from '@material-ui/icons/Message';
import CallIcon from '@material-ui/icons/Call';
import MeetIcon from '@material-ui/icons/People';

type Props = {

}

export const FlutterMessaging = (props: Props) => {
    const classes = useStyles({});
    return <>
        <img className={classes.image} src='/images/real-connection.jpg' alt='real-connection' />
        <div className={classes.section}>
            <Container maxWidth='md'>
                <Typography variant='h3'
                    align='center'>Real Conversations</Typography>
                <Typography variant='h6' gutterBottom align='center'>After you match, flutter guides you to your first in-person date.</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <div className={classes.item}>
                            <MessageIcon />
                            <Typography variant='h6'>Thoughtful Messaging</Typography>
                            <Typography variant='body1'>
                                We smartly avoid inbox-overload while giving you the ability to connect authentically.
                        </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <div className={classes.item}>
                            <CallIcon />
                            <Typography variant='h6'>Schedule a Phone Date</Typography>
                            <Typography variant='body1'>
                                Messaging is just not enough. We help you schedule your first phone-date to move the chains.
                        </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <div className={classes.item}>
                            <MeetIcon />
                            <Typography variant='h6'>Meet Offline</Typography>
                            <Typography variant='body1'>
                                With a strong foundation, <strong>Flutter</strong> helps you meet in the real world.
                        </Typography>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    </>
}

const useStyles = makeStyles(theme => createStyles({
    image: {
        width: '100%',
        display: 'block',
        maxHeight: '60vh',
        objectPosition: 'center',
        objectFit: 'cover',
    },
    section: {
        padding: theme.spacing(10, 0),
        background: theme.palette.divider,
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        '& svg': {
            width: 70,
            height: 70,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '50%',
            color: 'white',
            padding: theme.spacing(1.5),
            marginBottom: theme.spacing(1),
        },
        '& h6': {
            fontWeight: 'bold',
        }
    }
}))